document.querySelector(".popup-btn-ns").addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup-ns").style.display = 'block';
}, false);
document.querySelector(".popup-btn-ns").addEventListener('click', function () {
  document.querySelector(".popup-overlay-ns").style.display = 'block';
}, false);
document.querySelector(".popup-close-ns").addEventListener('click', function () {
  document.querySelector(".popup-ns").style.display = 'none';
  document.querySelector(".popup-overlay-ns").style.display = 'none';
}, false);
document.querySelector("body").addEventListener('click', function () {
  document.querySelector(".popup-ns").style.display = 'none';
  document.querySelector(".popup-overlay-ns").style.display = 'none';
}, false);
document.querySelector(".popup-ns").addEventListener('click', function (e) {
  e.stopPropagation();
}, false);

const slider = document.querySelector('.nfp-kits');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    cancelMomentumTracking();
  });
  
  
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  
  
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
    beginMomentumTracking();
  });
  
  
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    var prevScrollLeft = slider.scrollLeft;
    slider.scrollLeft = scrollLeft - walk;
    velX = slider.scrollLeft - prevScrollLeft;
  });
  
  // Momentum 
  
  var velX = 0;
  var momentumID;
  
  slider.addEventListener('wheel', (e) => {
    cancelMomentumTracking();
  });  
  
  function beginMomentumTracking(){
    cancelMomentumTracking();
    momentumID = requestAnimationFrame(momentumLoop);
  }
  function cancelMomentumTracking(){
    cancelAnimationFrame(momentumID);
  }
  function momentumLoop(){
    slider.scrollLeft += velX;
    velX *= 0.95; 
    if (Math.abs(velX) > 0.5){
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }